import type { RootState } from "@/app/store";
import type { ColorOptions, DrawingInfo, ShapeOptions, SizeOptions } from "@/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface DrawingState {
    selectedSize: SizeOptions;
    selectedColor: ColorOptions;
    drawingToolSelected: ShapeOptions;
    drawingInfo: DrawingInfo | null;
}

const initialState: DrawingState = {
    selectedSize: 'small',
    selectedColor: 'blue',
    drawingToolSelected: 'point',
    drawingInfo: null
}

export const drawingSlice = createSlice({
    name: 'drawing',
    initialState,
    reducers: {
        setDrawingToolSelected: (state, action: PayloadAction<ShapeOptions>) => {
            state.drawingToolSelected = action.payload;
        },
        setSelectedSize: (state, action: PayloadAction<SizeOptions>) => {
            state.selectedSize = action.payload;
        },
        setSelectedColor: (state, action: PayloadAction<ColorOptions>) => {
            state.selectedColor = action.payload;
        },
        setDrawingInfo: (state, action: PayloadAction<DrawingInfo | null>) => {
            state.drawingInfo = action.payload;
        }
    }
})

export const { setSelectedColor, setSelectedSize, setDrawingToolSelected, setDrawingInfo } = drawingSlice.actions;

export const sizeSelected = (state: RootState) => state.drawing.selectedSize;
export const colorSelected = (state: RootState) => state.drawing.selectedColor;
export const drawingToolSelected = (state: RootState) => state.drawing.drawingToolSelected;
export const drawingInfo = (state: RootState) => state.drawing.drawingInfo;

export default drawingSlice.reducer;
